<!--promotion-->
<ng-container *ngIf="promoItems.length">
  <div class="promo-items" [class.mb-3]="mode === 'expanded'">
    <header *ngIf="mode === 'expanded'">
      <span i18n="@@Delivery.PromotionalItems">Promotional Items</span>
      <span i18n="@@Money.Price">Price</span>
      <span i18n="@@Common.Quantity">Quantity</span>
      <span i18n="@@Money.Total">Total</span>
      <span i18n="@@Common.Actions">Actions</span>
    </header>

    <div class="items-wrapper">
      <ng-container
        [ngTemplateOutlet]="OrderItems"
        [ngTemplateOutletContext]="{ $implicit: promoItems }"
      ></ng-container>
    </div>
  </div>
</ng-container>

<header *ngIf="mode === 'expanded'">
  <span i18n="@@Delivery.Product">Product</span>
  <span i18n="@@Money.Price">Price</span>
  <span i18n="@@Common.Quantity">Quantity</span>
  <span i18n="@@Money.Total">Total</span>
  <span i18n="@@Common.Actions">Actions</span>
</header>

<div class="items">
  <div class="items-wrapper notice" *ngIf="unlistedOrderItems.length > 0">
    <div class="msg mat-caption" i18n="@@Checkout.UnavailableInDeliveryArea">
      These products are not available in your delivery area.
    </div>
    <ng-container
      [ngTemplateOutlet]="OrderItems"
      [ngTemplateOutletContext]="{ $implicit: unlistedOrderItems }"
    ></ng-container>
    <div class="action mat-caption">
      <ng-container i18n="@@Checkout.RemoveOrChangeDeliveryArea">
        Remove them from your bag or change your delivery area.
      </ng-container>
      <a
        mat-flat-button
        color="primary"
        xButtonSize="small"
        (click)="openRegionOverlay()"
        i18n="@@CallToAction.Change"
      >
        Change
      </a>
    </div>
  </div>

  <div class="items-wrapper notice" *ngIf="unavailableOrderItems.length > 0">
    <div class="msg mat-caption" i18n="@@Checkout.PleaseRemoveFromBag">
      These products are unavailable. Please remove them from your bag.
    </div>
    <ng-container
      [ngTemplateOutlet]="OrderItems"
      [ngTemplateOutletContext]="{ $implicit: unavailableOrderItems }"
    ></ng-container>
  </div>

  <div class="items-wrapper notice" *ngIf="outOfStockOrderItems.length > 0">
    <div class="msg" i18n="@@Note.OutOfStock">These products are out of stock.</div>
    <ng-container
      [ngTemplateOutlet]="OrderItems"
      [ngTemplateOutletContext]="{ $implicit: outOfStockOrderItems }"
    ></ng-container>
    <div class="action" i18n="@@Checkout.RemoveProductOrChangeQuantity.Note">
      Remove them from your bag or change your quantity.
    </div>
  </div>

  <div class="items-wrapper" *ngIf="availableItems.length > 0">
    <ng-container
      [ngTemplateOutlet]="OrderItems"
      [ngTemplateOutletContext]="{ $implicit: availableItems }"
    ></ng-container>
  </div>
</div>

<ng-template #OrderItems let-items>
  <div class="items">
    <x-order-item
      *ngFor="let item of items; trackBy: 'id' | trackBy"
      [item]="item"
      [currency]="order?.currency"
      [mode]="mode"
    ></x-order-item>
  </div>
</ng-template>
